import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function ThankYou() {
  useEffect(() => {
    document.title = "¡Gracias! — Zantravika";
  }, []);

  return (
    <main className="relative min-h-[100svh] flex items-center justify-center px-4 py-24 overflow-hidden grain" data-testid="thankyou-page">
      <div className="absolute inset-0 emerald-glow pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 max-w-2xl text-center"
      >
        <div className="inline-flex mb-8">
          <Logo size={44} />
        </div>
        <p className="eyebrow mb-4">Consulta recibida</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-balance">
          ¡Gracias por escribirnos!
        </h1>
        <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-xl mx-auto">
          Recibimos tu mensaje. Un integrante del equipo de Zantravika te va a responder a la brevedad al correo que dejaste. Mientras tanto, podés seguir explorando el sitio.
        </p>
        <div className="mt-10 flex justify-center">
          <Link to="/" className="btn-emerald text-sm" data-testid="thankyou-back-home-button">
            <ArrowLeft className="w-4 h-4" /> Volver al inicio
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
